import {PublicCancelPolicy} from '../api/venue/get-public-cancel-policy'

const HOUR_MS = 60 * 60 * 1000

// One stretch of time before the start and what a cancellation in it returns. `fromMs` null = since booking,
// `untilMs` null = until the start (a policy with no rules).
export type CancelPolicyStretch = {fromMs: number | null; untilMs: number | null; percent: number}

// The venue policy on a time line for a session starting at `startMs`: outside every window the default,
// then each window (the narrowest window that holds decides, as on the server). Stretches already over
// at `nowMs` are left out.
export const venuePolicyStretches = (
  policy: Pick<PublicCancelPolicy, 'defaultRefundPercent' | 'rules'>,
  startMs: number,
  nowMs: number = Date.now(),
): CancelPolicyStretch[] => {
  const percentOutside = policy.defaultRefundPercent ?? 100
  const rules = [...(policy.rules ?? [])].sort((a, b) => b.withinHours - a.withinHours)
  if (!rules.length) {
    return [{fromMs: null, untilMs: null, percent: percentOutside}]
  }
  const stretches: CancelPolicyStretch[] = [
    {fromMs: null, untilMs: startMs - rules[0].withinHours * HOUR_MS, percent: percentOutside},
    ...rules.map((rule, index) => ({
      fromMs: startMs - rule.withinHours * HOUR_MS,
      untilMs: index + 1 < rules.length ? startMs - rules[index + 1].withinHours * HOUR_MS : startMs,
      percent: rule.refundPercent,
    })),
  ]
  return stretches.filter((s) => s.untilMs === null || s.untilMs > nowMs)
}
